module.exports = __webpack_public_path__ + "img/hll-xcx-code-2.ed43e316.png";